import {
  FETCH_RATES_REQUEST,
  FETCH_RATES_SUCCESS,
  FETCH_RATES_FAILURE,
  CREATE_RATE_REQUEST,
  CREATE_RATE_SUCCESS,
  CREATE_RATE_FAILURE,
  UPDATE_RATE_REQUEST,
  UPDATE_RATE_SUCCESS,
  UPDATE_RATE_FAILURE,
  DELETE_RATE_REQUEST,
  DELETE_RATE_SUCCESS,
  DELETE_RATE_FAILURE,
} from "../actions/types";

const initialState = {
  rates: [],
  loading: false,
  error: null,
  message: "",
};

const rateReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RATES_REQUEST:
    case CREATE_RATE_REQUEST:
    case UPDATE_RATE_REQUEST:
    case DELETE_RATE_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_RATES_SUCCESS:
      return { ...state, loading: false, rates: action.payload, message: "Rates loaded successfully" };

    case CREATE_RATE_SUCCESS:
      return { ...state, loading: false, rates: [...state.rates, action.payload], message: "Rate created successfully" };

    case UPDATE_RATE_SUCCESS:
      return {
        ...state,
        loading: false,
        rates: state.rates.map((rate) =>
          rate.id === action.payload.id ? action.payload : rate
        ),
        message: "Rate updated successfully",
      };

    case DELETE_RATE_SUCCESS:
      return {
        ...state,
        loading: false,
        rates: state.rates.filter((rate) => rate.id !== action.payload),
        message: "Rate deleted successfully",
      };

    case FETCH_RATES_FAILURE:
    case CREATE_RATE_FAILURE:
    case UPDATE_RATE_FAILURE:
    case DELETE_RATE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default rateReducer;
